<template>
  <v-chip v-bind:class="[ 'sf-pill', `sf-pill--${pillColor}` ]"
          small>
    {{ $t(status) }}
  </v-chip>
</template>

<script>
  const COLORS = {
    Pending: 'grey',
    Running: 'accent',
    Completed: 'success',
    CompletedWithErrors: 'error',
    Cancelled: 'grey',
    Sending: 'accent',
    Sent: 'success',
    Failed: 'error',
    Skipped: 'grey'
  }

  export default {
    computed: {
      color() {
        return COLORS[this.status] || 'grey'
      },
      pillColor() {
        return this.color === 'grey' ? 'neutral' : this.color
      }
    },
    name: 'EmailJobStatusChip',
    props: {
      status: String
    }
  }
</script>

<i18n>
  {
    "de": {
      "Pending": "Wartet",
      "Running": "Läuft",
      "Completed": "Abgeschlossen",
      "CompletedWithErrors": "Mit Fehlern",
      "Cancelled": "Abgebrochen",
      "Sending": "Wird gesendet",
      "Sent": "Gesendet",
      "Failed": "Fehlgeschlagen",
      "Skipped": "Übersprungen"
    },
    "en": {
      "Pending": "Pending",
      "Running": "Running",
      "Completed": "Completed",
      "CompletedWithErrors": "With errors",
      "Cancelled": "Cancelled",
      "Sending": "Sending",
      "Sent": "Sent",
      "Failed": "Failed",
      "Skipped": "Skipped"
    }
  }
</i18n>
